export const LABEL_STYLES = {
  'Pending Procurement – Tentative': 'bg-orange-100 text-orange-800 border-orange-300',
  'Tentatively Reserved': 'bg-amber-100 text-amber-800 border-amber-300',
  'Ready to Assign': 'bg-emerald-100 text-emerald-800 border-emerald-300',
  'Assigned to Production': 'bg-blue-100 text-blue-800 border-blue-300',
  'Partially Allocated': 'bg-violet-100 text-violet-800 border-violet-300',
  'Allocation Pending': 'bg-zinc-100 text-zinc-700 border-zinc-300',
  'Production Completed': 'bg-green-100 text-green-800 border-green-300',
  'Ready to Dispatch': 'bg-emerald-100 text-emerald-800 border-emerald-300',
  'Scheduled for Dispatch': 'bg-emerald-100 text-emerald-800 border-emerald-300',
  'Partially Dispatched': 'bg-teal-100 text-teal-800 border-teal-300',
  'Dispatched': 'bg-green-200 text-green-900 border-green-400',
  'Pending for Installation': 'bg-teal-100 text-teal-800 border-teal-300',
  'Installation Completed': 'bg-green-200 text-green-900 border-green-400',
};

export const RISK_STYLES = {
  overdue: 'bg-red-600 text-white',
  high: 'bg-red-100 text-red-800 border border-red-300',
  medium: 'bg-amber-100 text-amber-800 border border-amber-300',
  low: 'bg-blue-100 text-blue-700 border border-blue-200',
  none: 'bg-zinc-100 text-zinc-500',
};

export function labelClass(label) {
  return LABEL_STYLES[label] || 'bg-zinc-100 text-zinc-700 border-zinc-300';
}

export function riskClass(risk) {
  return RISK_STYLES[risk] || RISK_STYLES.none;
}

export function fmtD(iso) {
  if (!iso) return '—';
  try {
    const [y, m, d] = iso.split('-');
    return `${d}-${m}-${y}`;
  } catch { return iso; }
}
